/**
 * @generated SignedSource<<d5c56329dc7ef1f8e0434a405b4aafab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductShipping_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_viewer">;
  readonly " $fragmentType": "ProductShipping_viewer";
};
export type ProductShipping_viewer$key = {
  readonly " $data"?: ProductShipping_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductShipping_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductShipping_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a567b60f6dd2189ea4c31cb11fad7106";

export default node;
